import React from "react";
import PropTypes from "prop-types";
import style from "./header.css";
import SVGIcon from "../common/svg-icon";

function Header({ index, title, onBackClick, onCloseClick }) {
    return (
        <header className={style.container}>
            {index ? (
                <div className={style.back} onClick={onBackClick}>
                    <SVGIcon name="chevron" flip />
                </div>
            ) : null}
            <h1 className={style.title}>{title}</h1>
            <div className={style.close} onClick={onCloseClick}>
                <SVGIcon name="cross" />
            </div>
        </header>
    );
}

export default Header;

Header.propTypes = {
    index: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    onBackClick: PropTypes.func.isRequired,
    onCloseClick: PropTypes.func.isRequired
};
